(function ($) {

    var myVar;

    $(document).ready(function () {
      	// Footer Menu Accordion Mobile
      	$('.footer__menu .footer__heading').on('click', function (e) {
            e.preventDefault();
          	$(this).toggleClass('active');
            $(this).next('ul').slideToggle();
        });
      
        // SIZE GUIDE POPUP
        $('.sizeGuideButton,a[href="#popupSizeGuide"]').magnificPopup({
            type: 'inline',
            fixedBgPos: 'true',
            callbacks: {
                beforeOpen: function () {
                    $('body').addClass('no-scroll');
                },
                beforeClose: function () {
                    $('body').removeClass('no-scroll');
                }
            }
        });
      
      	// SIZE GUIDE CM / INCH BUTTONS

        $('.sizeBtn.cm').on('click', function (e) {
            e.preventDefault();
            $(this).siblings('.sizeBtn.in').removeClass('active');
            $(this).addClass('active');
            $(this).siblings('table.cm').addClass('active');
            $(this).siblings('table.in').removeClass('active');
        });

        $('.sizeBtn.in').on('click', function (e) {
            e.preventDefault();
            $(this).siblings('.sizeBtn.cm').removeClass('active');
            $(this).addClass('active');
            $(this).siblings('table.in').addClass('active');
            $(this).siblings('table.cm').removeClass('active');
        });

        // SIZE GUIDE SHOW / HIDE BUTTONS

        // $('.knickersTableContainer').hide();
        // $('.bodysuitTableContainer').hide();
        // $('.softCupTableContainer').hide();
        // $('.braTableContainer').hide();

        $('.knickersButton').on('click', function (e) {
          	$('.knickersButton').removeClass('active');
            e.preventDefault();
            $(this).toggleClass('active');
            $('.knickersTableContainer').slideToggle();
            $('.bodysuitTableContainer').slideUp();
            $('.softCupTableContainer').slideUp();
            $('.braTableContainer').slideUp();
        });

        $('.bodysuitButton').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $('.bodysuitTableContainer').slideToggle();
            $('.knickersTableContainer').slideUp();
            $('.softCupTableContainer').slideUp();
            $('.braTableContainer').slideUp();
        });

        $('.softCupButton').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $('.softCupTableContainer').slideToggle();
            $('.knickersTableContainer').slideUp();
            $('.bodysuitTableContainer').slideUp();
            $('.braTableContainer').slideUp();
        });

        $('.braButton').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $('.braTableContainer').slideToggle();
            $('.knickersTableContainer').slideUp();
            $('.bodysuitTableContainer').slideUp();
            $('.softCupTableContainer').slideUp();
        });
      
      	// OWL CAROUSEL - HOME

        $('.productCarousel .owl-carousel').owlCarousel({
            loop: true,
            margin: 30,
            items: 4,
            nav: true,
            responsiveClass: true,
            responsive: {

                0: {
                    items: 2,
                    nav: true,
                    dots: false,
                    loop: false,
                    margin: 15
                },

                600: {
                    items: 3,
                    nav: false,
                    loop: false,
                    dots: true,
                    margin: 15
                },

                1000: {
                    items: 4,
                    nav: true,
                    loop: false,
                    dots: true
                }
            }
        });
      
      /**
       * Editorial Script
       * ------------------------------------------------------------------------------
       * A file that contains scripts highly couple code to the Editorial section.
       *
         * @namespace editorial
       */
      
      if($('.editorial__slider').length > 0) {
        $('.editorial__slider').slick({
          centerMode: true,
          centerPadding: 0,
          adaptiveHeight: true,
          prevArrow: "<div class = 'editorial__slider-arrow editorial__slider-arrow--left'> <svg width='20px' height='38px' viewBox='0 0 20 38' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><g   stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g  transform='translate(-190.000000, -326.000000)' fill='#726D75'><g  transform='translate(0.000000, 1.000000)'><path d='M205.932203,343.648649 L190.466102,327.542998 C190.155366,327.260439 190,326.914314 190,326.504608 C190,326.094902 190.155366,325.734646 190.466102,325.423833 C190.748589,325.141274 191.094631,325 191.504238,325 C191.913844,325 192.259886,325.141274 192.542373,325.423833 L209.533896,342.589069 C209.844632,342.871623 210,343.224816 210,343.648649 C210,344.072482 209.844632,344.425675 209.533896,344.708228 L192.542373,361.873464 C192.259886,362.156021 191.913844,362.297297 191.504238,362.297297 C191.094631,362.297297 190.748589,362.156021 190.466102,361.873464 C190.155366,361.590908 190,361.237717 190,360.813882 C190,360.390047 190.155366,360.036856 190.466102,359.7543 L205.932203,343.648649 Z'   transform='translate(200.000000, 343.648649) rotate(180.000000) translate(-200.000000, -343.648649) '></path></g></g></g></svg></div>",
          nextArrow: "<div class = 'editorial__slider-arrow editorial__slider-arrow--right'> <svg width='20px' height='38px' viewBox='0 0 20 38' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> <g   stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'> <g  transform='translate(-1231.000000, -323.000000)' fill='#726D75'> <g  transform='translate(0.000000, 1.000000)'> <path d='M1246.9322,340.648649 L1231.4661,324.542998 C1231.15537,324.260439 1231,323.914314 1231,323.504608 C1231,323.094902 1231.15537,322.734646 1231.4661,322.423833 C1231.74859,322.141274 1232.09463,322 1232.50424,322 C1232.91384,322 1233.25989,322.141274 1233.54237,322.423833 L1250.5339,339.589069 C1250.84463,339.871623 1251,340.224816 1251,340.648649 C1251,341.072482 1250.84463,341.425675 1250.5339,341.708228 L1233.54237,358.873464 C1233.25989,359.156021 1232.91384,359.297297 1232.50424,359.297297 C1232.09463,359.297297 1231.74859,359.156021 1231.4661,358.873464 C1231.15537,358.590908 1231,358.237717 1231,357.813882 C1231,357.390047 1231.15537,357.036856 1231.4661,356.7543 L1246.9322,340.648649 Z'  ></path> </g> </g> </g> </svg></div>",
        });
        $('.editorial__slider .editorial__excerpt').trunk8({
          lines: 3
        });
        $('.editorial__slider .editorial__content').matchHeight();
        $('.editorial__slider .editorial__title > a').trunk8();
      }

    });

    function initPopup() {
        //Cookies.remove('popup');
        if (Cookies.get('popup') == 'displayed') {
            //jQuery('.popupLink').trigger('click');
        } else {
            $('.popupLink').trigger('click');
            //console.log('test');
            Cookies.set('popup', 'displayed', { expires: 7 });
        }
    }

})(window.jQuery);
